import { Form, Grid, Button } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import React from 'react';

import { SelectField, InputField, Toggle } from 'Common/SemanticWrapper';
import { NYSirsAutoExportFieldEnum as Fields } from 'Common/FieldEnum';
import { NEW_YORK_SIRS_AUTO_EXPORT_FORM_NAME } from 'Common/FormEnum';
import { hasCsvExtension } from 'Common/FormHelper';
import { TitledCard } from 'Components/';

import { dayOptions, hours, minutes, amOrPm } from '../constants/sirsConstants';

import 'Styles/pages/nysirsexport/nysirsexport.less';

const NewYorkSirsAutoExportForm = (props) => {
  return (
    <Form
      name={NEW_YORK_SIRS_AUTO_EXPORT_FORM_NAME}
      style={{ marginBottom: '200px' }}
    >
      <TitledCard
        title={'Auto Export Setup'}
        style={{ width: '60vw', minWidth: '700px' }}
      >
        <Grid className={'sirsAutoExportGrid'}>
          <Grid.Row className={'sirs-First-Row'}>
            <Grid.Column className={'sirsCol'}>
              <Field
                label={'Enable Export'}
                disabled={props.loading}
                component={Toggle}
                name={Fields.EnabledToggle}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className={'sirsRow'}>
            <Grid.Column width={12}>
              <Field
                multiple
                selectAllButton
                selectNoneButton
                label={'Export Schedule'}
                component={SelectField}
                name={Fields.DayPicker}
                options={dayOptions}
                disabled={props.loading}
                placeholder={'Days'}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            columns={16}
            className={'sirsRow times-row'}
            style={{ display: 'table' }}
          >
            <Grid.Column width={4}>
              <Field
                name={Fields.Hour}
                component={SelectField}
                type="text"
                label=""
                options={hours}
                placeholder={'Hour'}
                disabled={props.loading}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <Field
                name={Fields.Minute}
                component={SelectField}
                type="text"
                label=""
                options={minutes}
                placeholder={'Minutes'}
                disabled={props.loading}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <Field
                name={Fields.AmOrPm}
                component={SelectField}
                type="text"
                label=""
                options={amOrPm}
                placeholder={'AM or PM'}
                disabled={props.loading}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column
              width={6}
              style={{ minWidth: '225px', height: '135px' }}
            >
              <Field
                name={Fields.FileName}
                component={InputField}
                type="text"
                label="Export File Name"
                disabled={props.loading}
                maxLength={30}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <Button
                onClick={() => props.submit()}
                loading={props.loading}
                disabled={props.loading}
              >
                Save Configuration
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    </Form>
  );
};

const validate = (values, props) => {
  const errors = {};

  if (
    values[Fields.EnabledToggle] &&
    (!values[Fields.DayPicker] ||
      (Array.isArray(values[Fields.DayPicker]) &&
        values[Fields.DayPicker].length === 0))
  ) {
    errors[Fields.DayPicker] = 'You must select at least one day';
  }

  if (values[Fields.EnabledToggle] && !values[Fields.Hour]) {
    errors[Fields.Hour] = 'You must select an hour';
  }

  if (values[Fields.EnabledToggle] && !values[Fields.AmOrPm]) {
    errors[Fields.AmOrPm] = 'You must select AM or PM';
  }

  if (
    values[Fields.EnabledToggle] &&
    !values[Fields.Minute] &&
    values[Fields.Minute] !== 0
  ) {
    errors[Fields.Minute] = 'You must select a minute';
  }

  if (
    values[Fields.FileName] &&
    !/^[a-zA-Z0-9._-]*$/.test(values[Fields.FileName])
  ) {
    errors[Fields.FileName] = 'You are using an unsupported character';
  }

  if (!values[Fields.FileName]) {
    errors[Fields.FileName] = 'File name required';
  }
  if (values[Fields.FileName] && hasCsvExtension(values[Fields.FileName])) {
    errors[Fields.FileName] = 'File Name must end with ".csv"';
  }
  if (
    values[Fields.FileName] &&
    props.usedFileNames.includes(values[Fields.FileName]) &&
    values[Fields.FileName] !== props.initialFileName
  ) {
    errors[Fields.FileName] = 'File Name is used by other export';
  }

  return errors;
};

const NewYorkSirsAutoExportFormExport = reduxForm({
  form: NEW_YORK_SIRS_AUTO_EXPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(withRouter(NewYorkSirsAutoExportForm));

export { NewYorkSirsAutoExportFormExport };



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/components/NewYorkSirsAutoExportForm.js